/**
 * ConfirmModal — destructive-action confirmation dialog.
 * Used for discard / exit-edit-mode / navigate-while-dirty flows.
 */
import { Box, HStack, Pressable, VStack } from 'native-base';
import { Text } from '@pimm/base';

type Props = {
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmModal = ({ title, body, confirmLabel, cancelLabel, onConfirm, onCancel }: Props) => (
  <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={20}>
    <Pressable position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(0,0,0,0.5)" onPress={onCancel} />
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      alignItems="center"
      justifyContent="center"
      // @ts-ignore
      pointerEvents="box-none"
    >
      <Box bg="white" rounded="xl" maxW="360px" w="90%" shadow={9}>
        <VStack space={2} px={5} pt={5} pb={4}>
          <Text size="md" fontWeight={600} color="gray.900">
            {title}
          </Text>
          <Text size="sm" color="gray.500" lineHeight={20}>
            {body}
          </Text>
        </VStack>
        <HStack space={3} justifyContent="flex-end" px={5} py={4} borderTopWidth={1} borderColor="gray.200">
          <Pressable onPress={onCancel}>
            <Box px={4} py={2} rounded="lg" borderWidth={1} borderColor="gray.300" bg="white">
              <Text size="sm" fontWeight={500} color="gray.700">
                {cancelLabel}
              </Text>
            </Box>
          </Pressable>
          <Pressable onPress={onConfirm}>
            <Box px={4} py={2} rounded="lg" bg="error.600">
              <Text size="sm" fontWeight={600} color="white">
                {confirmLabel}
              </Text>
            </Box>
          </Pressable>
        </HStack>
      </Box>
    </Box>
  </Box>
);
